import { Icon } from '@euler/components/Icomoon';
import { Input } from '@euler/components/form/Input';
import { useShowFloatingTextInput } from '@euler/components/input/FloatingTextInput';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { usePersistFn } from '@euler/utils/hooks';
import { memo } from 'react';
import { Platform } from 'react-native';
import { useOrderFlowContext } from '../../../../OrderFlowContext';
import { Cell } from '../components/Cell';
import { IconWrapper } from '../components/IconWrapper';
import { Row } from '../components/Row';
import { useOrderFormStyles } from '../components/styles';

export const OrderRemarkRow = memo(
  ({ required, ...props }: { required?: boolean; disabled?: boolean }) => {
    const {
      theme,
      formController: { form },
    } = useOrderFlowContext();

    const { iconColor, placeholderColor } = theme;
    const showFloatingTextInput = useShowFloatingTextInput();
    const styles = useOrderFormStyles();
    const { rpx } = useResponsiveContext();

    const onPress = usePersistFn(() => {
      showFloatingTextInput({
        value: form.remark.value,
        onDone: form.remark.update,
        placeholder: '客户服务备注',
      });
    });

    return (
      <Row
        errorProp="remark"
        detailIcon={'disclosure'}
        icon={
          <IconWrapper>
            <Icon name="note" size={rpx(20)} color={iconColor} />
          </IconWrapper>
        }
        onPress={onPress}
        {...props}
      >
        <Cell label="服务备注" required={required}>
          <Input
            style={styles.formInput}
            placeholderTextColor={placeholderColor}
            value={form.remark.value ?? ''}
            placeholder="可选"
            errorMsg={form.remark.error}
            editable={Platform.OS === 'web'}
            onChangeText={
              Platform.OS === 'web' ? form.remark.update : undefined
            }
            multiline
            pointerEvents={Platform.OS === 'web' ? undefined : 'none'}
          />
        </Cell>
      </Row>
    );
  },
);
